export default "__VITE_ASSET__1f9bd3c5__"